import {inject, Injectable} from '@angular/core';
import {ApiScenarioHistoryListResponseDto, ApiScenarioListResponseDto, ApiScenarioOperationResponseDto, ScenarioHistoriesApiService, ScenarioOperation, ScenariosApiService} from '@birco/rainmesh-api';
import {Observable} from 'rxjs';
import { ScenarioStateService } from '../api/scenario-state-service.interface';
import { ScenarioHistoryFilter } from '../../../features/scenarios/state/scenario.state';

@Injectable({
  providedIn: 'root'
})
export class ScenarioStateServiceImpl implements ScenarioStateService {
  private scenarioApiService = inject(ScenariosApiService);
  private scenarioHistoriesApiService = inject(ScenarioHistoriesApiService);

  getScenarios(): Observable<ApiScenarioListResponseDto> {
    return this.scenarioApiService.getScenarios()
  }

  getScenarioHistory(options: ScenarioHistoryFilter): Observable<ApiScenarioHistoryListResponseDto> {
    return this.scenarioHistoriesApiService.getScenarioHistories(
      options.pageSize,
      options.page,
      options.startDate,
      options.endDate,
    );
  }

  runScenario(id: string): Observable<ApiScenarioOperationResponseDto> {
    return this.scenarioApiService.executeScenarioOperation(id, {operation: ScenarioOperation.RUN})
  }

  stopScenario(id: string): Observable<ApiScenarioOperationResponseDto> {
    return this.scenarioApiService.executeScenarioOperation(id, {operation: ScenarioOperation.STOP})
  }
}
